import { Directive, ElementRef, HostListener, inject } from '@angular/core';

/** Barrierefreiheit: Findet und fokussiert nach der Löschen-Aktion den Button mit hisImage="plus_circ_green" */
@Directive( {
    selector: '[hisImage="delete"]',
    standalone: false
} )
export class HisDeleteActionDirective {
    private el = inject(ElementRef);


    @HostListener('click') clickEvent() {
        for(let attribute of this.el.nativeElement.attributes){
            if(attribute.nodeName === 'hisimage') {
                if(attribute.value === 'DELETE') {
                    let nearestPanel = this.el.nativeElement.closest('p-panel');
                    setTimeout(() => {
                        let addButton = nearestPanel?.querySelector('button[hisimage="plus_circ_green"]');
                        if (addButton) {
                            addButton.focus();
                        }
                    }, 5);
                }
                break;
            }
        }
    }
}
